import { useQuery } from '@tanstack/react-query';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { getCurrentGatewayUrl } from '../../utils/environmentDetection';
import { getAuthHeaders } from '../../utils/authHeaders';

export const getApplicationDomainsQueryKey = (applicationId?: string) =>
  ['application-domains', applicationId] as const;

export function useApplicationDomains({
  applicationId,
  tenantId,
}: {
  applicationId?: string;
  tenantId?: string;
}) {
  return useQuery({
    queryKey: getApplicationDomainsQueryKey(applicationId),
    queryFn: async () => {
      if (!applicationId || !tenantId) {
        return { domains: [] };
      }

      const authHeaders = await getAuthHeaders();
      const response = await applicationsClient.getApplicationDomains({
        params: { id: applicationId },
        overrideClientOptions: {
          baseUrl: `${getCurrentGatewayUrl()}/orchestrator`,
        },
        extraHeaders: {
          ...authHeaders,
        },
      });

      if (response.status === 200) {
        return response.body;
      }

      throw new Error('Failed to fetch domains');
    },
    enabled: !!applicationId && !!tenantId,
    refetchOnWindowFocus: false,
  });
}
